import React from 'react'

const TickApporve16pxSvg = (props) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.00016 1.33325C4.32683 1.33325 1.3335 4.32658 1.3335 7.99992C1.3335 11.6733 4.32683 14.6666 8.00016 14.6666C11.6735 14.6666 14.6668 11.6733 14.6668 7.99992C14.6668 4.32658 11.6735 1.33325 8.00016 1.33325ZM11.1868 6.46658L7.40683 10.2466C7.3135 10.3399 7.18683 10.3933 7.0535 10.3933C6.92016 10.3933 6.7935 10.3399 6.70016 10.2466L4.8135 8.35992C4.62016 8.16658 4.62016 7.84658 4.8135 7.65325C5.00683 7.45992 5.32683 7.45992 5.52016 7.65325L7.0535 9.18658L10.4802 5.75992C10.6735 5.56659 10.9935 5.56659 11.1868 5.75992C11.3802 5.95325 11.3802 6.26658 11.1868 6.46658Z" fill="#058900" />
        </svg>

    )
}

export default TickApporve16pxSvg